import React from "react";
import GoogleMapReact from "google-map-react";
import { useParams } from "react-router-dom";
import { useVenue } from "@queries/useVenue";
import MapsMarkerIcon from "@components/Icons/MapsMarkerIcon";

const VenueInformation = () => {
    const { id, venue_name } = useParams();
    const { venue } = useVenue(id, venue_name);

    const {
        address,
        city,
        description,
        email,
        latitude,
        longitude,
        name,
        phone,
        postcode,
        state,
        website,
    } = venue;

    const venueAddress = `${address}, ${city}, ${state}, ${postcode}`;

    return (
        <div className="search-details-venue__tab-wrapper">
            <div className="search-details-venue__detail">
                <h2 className="search-details-venue__about-title">{name}</h2>
                <h3 className="search-details-venue__about-text">
                    {description}
                </h3>
                {venueAddress && <div className="search-details-venue__about-text">Address: <span
                    className="search-details-venue__about-text">{venueAddress}</span></div>}
                {website && <div className="search-details-venue__about-text">Website: <a href={website} target="_blank"
                    rel="noopener noreferrer"
                    className="search-details-venue__link">{website}</a>
                </div>}
                {phone && <div className="search-details-venue__about-text">Phone: <span
                    className="search-details-venue__about-text">{phone}</span></div>}
                {email && <div className="search-details-venue__about-text">Email: <span
                    className="search-details-venue__about-text">{email}</span></div>}
            </div>
            <div className="search-details-venue__map-wrap">
                {latitude && longitude && (
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: "AIzaSyC4N1BHxxWohTt7moat_Mq3x5Gw5U6Cvqw" }}
                        className="map"
                        yesIWantToUseGoogleMapApiInternals
                        region="au"
                        zoom={11}
                        center={{ lat: Number(latitude), lng: Number(longitude) }}
                    >
                        <MapsMarkerIcon lat={latitude} lng={longitude} className="venue__marker" />
                    </GoogleMapReact>
                )}
            </div>
        </div>
    );
};

export default VenueInformation;
